var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHandEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6001 36.4719C19.6401 36.8479 25.2241 37.8719 28.9121 38.3839C30.7121 38.6319 41.4241 39.9839 40.9841 42.8479C40.6241 45.1519 33.3201 45.2959 25.5841 43.5999",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.52 37.968V49.04C16.52 49.04 29.864 52.24 35.72 52.24C42.576 52.24 56.4 41.84 56.4 41.84C53.152 37.72 46.32 40.328 42.8 42.08",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4159 50.032L16.1599 50.92L10.1839 50.288L8.46387 35.2C11.2559 34.352 16.4639 34.952 16.4639 34.952L16.4079 36.328",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4562 39.288C12.9555 39.288 13.3602 38.8832 13.3602 38.384C13.3602 37.8847 12.9555 37.48 12.4562 37.48C11.957 37.48 11.5522 37.8847 11.5522 38.384C11.5522 38.8832 11.957 39.288 12.4562 39.288Z",
    fill: "#00005A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.441 10.5384C38.1976 10.3198 29.7979 7.76467 25.7628 16.086C24.3017 19.0846 22.2748 26.75 26.6643 31.0793C30.0279 34.4215 35.2256 36.0146 39.2918 34.3091C53.5856 28.2993 47.8345 12.0065 39.441 10.5384Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.184 19.72L11.4 18.232L11 19.776L16.792 21.272L17.184 19.72ZM55.768 21.272L61.56 19.776L61.16 18.232L55.376 19.72L55.768 21.272ZM11.248 29.528L12.048 30.912L17.192 27.872L16.392 26.488L11.248 29.528ZM55.352 27.872L60.496 30.912L61.296 29.528L56.144 26.488L55.352 27.872ZM54.856 9L51.816 14.144L53.192 14.944L56.232 9.792L54.856 9ZM16.328 9.8L19.368 14.952L20.744 14.152L17.704 9.008L16.328 9.8Z",
    fill: "url(#paint0_linear_16449_1586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16449_1586",
    x1: 31.16,
    y1: 5.336,
    x2: 39.656,
    y2: 36.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHandEmpty);
export default __webpack_public_path__ + "static/media/icon-hand-empty.373b1998e261a2ceaffe7e76433cb873.svg";
export { ForwardRef as ReactComponent };